export function detectSkill(text) {
    if (/^\[\[(.*?)\]\]$/.test(text)) {
        return RegExp.$1;
    }
    return null;
}
//# sourceMappingURL=detectSkill.js.map